import './avatar.scss';

export default function Avatar({ className, image }) {

    return (
        <div className={'avatar-component ' + (className || '' )} style={{ backgroundImage: `url("${image}")` }}></div>
    )
}